import axios from "axios";

export const getAddressesAPI = (payload) => {
    return axios.get(`{server}/admin/users/providers/addresses`).then(res => res.data.success)
}